import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { StateObservable, Store } from "@ngrx/store";
import { BehaviorSubject } from "rxjs";

import { BlockUserComponent } from "@serasa/core/modules/dashboard/components/block-user/block-user.component";
import { DeleteUserComponent } from "@serasa/core/modules/dashboard/components/delete-user/delete-user.component";
import { ResetPasswordComponent } from "@serasa/core/modules/dashboard/components/reset-password/reset-password.component";
import { UnblockUserComponent } from "@serasa/core/modules/dashboard/components/unblock-user/unblock-user.component";
import { User } from "@serasa/core/modules/users/interfaces/user.interface";
import { selectToggleSidenav } from "@serasa/core/modules/users/state/selectors/user.selectors";

@Injectable({
  providedIn: "root",
})
export class SidenavManagerService {
  public openSidenav$?: StateObservable;
  public currentUser$ = new BehaviorSubject<Partial<User>>({});
  public navigate$ = new BehaviorSubject<string>("");
  public resetPasswordFlow$ = new BehaviorSubject<boolean>(false);
  public isFromReset$ = new BehaviorSubject<boolean>(false);

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    public dialog: MatDialog,
    private readonly store: Store,
  ) {
    this._sidenavHandler();
  }

  private _sidenavHandler(): void {
    this.openSidenav$ = this.store.select(selectToggleSidenav);

    this.openSidenav$.subscribe((isOpen) => {
      if (isOpen) {
        this.document.body.classList.add("no-scrolling");
        this.navigate$.next("details");
      } else {
        this.document.body.classList.remove("no-scrolling");
        this.navigate$.next("");
      }
    });
  }

  public startBlockUserFlow(): void {
    this.dialog.open(BlockUserComponent, {
      data: {
        byUserDetails: true,
      },
      width: '513px',
    });
  }

  public startUnblockUserFlow(): void {
    this.dialog.open(UnblockUserComponent, {
      data: {
        byUserDetails: true,
      },
      width: '513px',
    });
  }

  public startResetFlow(status: string): void {
    this.resetPasswordFlow$.next(status === "true");
    this.dialog.open(ResetPasswordComponent, {
      data: {
        byUserDetails: true,
      },
      width: '513px',
    });
  }

  public startDeleteUser(): void {
    this.dialog.open(DeleteUserComponent, {
      minHeight: "322px",
      width: '513px'
    });
  }

}
